import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import StoryCard from './StoryCard';
import { CATEGORY_COLORS } from './HeroSection';

export default function CategoryShowcase({ category, articles, index, t }) {
  if (!articles || articles.length === 0) return null;
  const color = CATEGORY_COLORS[category] || '#1a56db';
  const slug = category.toLowerCase().replace(/\s+/g, '-').replace(/č/g, 'c').replace(/ć/g, 'c').replace(/đ/g, 'd').replace(/š/g, 's').replace(/ž/g, 'z');
  const style = index % 4;

  return (
    <section data-testid={`category-showcase-${slug}`} className="mb-8">
      <div className="flex items-center justify-between mb-4">
        <h2 className="font-serif text-xl font-bold text-navy dark:text-white flex items-center gap-2">
          <span className="w-1 h-6 rounded-full" style={{ backgroundColor: color }} />
          {category}
        </h2>
        <Link to={`/category/${slug}`} className="text-xs font-display font-semibold flex items-center gap-1 transition-colors hover:opacity-80" style={{ color }}>
          {t('view_all')} <ChevronRight size={13} />
        </Link>
      </div>

      {style === 0 && (
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
          <StoryCard article={articles[0]} featured />
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {articles.slice(1, 5).map(a => <StoryCard key={a.slug} article={a} />)}
          </div>
        </div>
      )}

      {style === 1 && (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {articles.slice(0, 4).map(a => <StoryCard key={a.slug} article={a} />)}
        </div>
      )}

      {style === 2 && (
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
          <div className="lg:col-span-2">
            <StoryCard article={articles[0]} featured />
          </div>
          <div className="space-y-1">
            {articles.slice(1, 6).map(a => <StoryCard key={a.slug} article={a} compact />)}
          </div>
        </div>
      )}

      {style === 3 && (
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
          {articles.slice(0, 3).map(a => <StoryCard key={a.slug} article={a} />)}
        </div>
      )}
    </section>
  );
}
